let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lBret")).then(() => parcelRequire('lT9gU'));